import React, { useEffect, useState } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { QrReader } from 'react-qr-reader'

export default function Dashboard() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {client} = useAuth()
    const navigate = useNavigate()

    const [result, setResult] = useState('')
    const [restaurantId, setRestaurantId] = useState(null)

    useEffect(() => {
        if(client){
            if(client?.restaurant){
                setRestaurantId(client.restaurant)
            }
        }
    },[dispatch, t, client])

	useEffect(() => {
		if(result){
            navigate(result)
		}
	},[result, navigate])

    return (
        <Container className='p-5'> 
            <Row className='sd-row-dashboard'>
                <Col>
                    <div className='sd-label-dashboard'>{t('kitchen.dashboard.welcome')}</div>
                    <div className="sd-label-userdashboard colornaranja">{client?.firstname}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <div className="sd-label-subdashboard">{t('kitchen.dashboard.subwelcome')}</div>
                </Col>
            </Row>
            {client?.restaurant
            ?
            <>
                <Row className='mb-5'>
                    <Col>
                        <Link to={'#'}>
                            <div className='btn-dashboard-orange p-4'>
                            <h1>{t('kitchen.dashboard.checkqr')}</h1>
                                <QrReader
                                    onResult={(result, error) => {
                                        if (!!result) { setResult(result?.text) }
                                    }}
                                    constraints={{
                                        facingMode: 'environment'
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </Link>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                    {
                        process.env.REACT_APP_PLATFORM === 'app'
                        ?
                        <Link to={"/kitchen/ordersfordeliveryapp/"+restaurantId} className='btn btn-dashboard btn-dashboard-white'>
                            {t('kitchen.dashboard.ordersfordelivery')}
                        </Link>
                        :
                        <Link to={"/kitchen/ordersfordelivery/"+restaurantId} className='btn btn-dashboard btn-dashboard-white'>
                            {t('kitchen.dashboard.ordersfordelivery')}
                        </Link>
                    }
                    </Col>
                    <Col xs={12} md={6}>
                        <Link to={"/kitchen/ordersdelivered/"+restaurantId} className='btn btn-dashboard btn-dashboard-white'>
                            {t('kitchen.dashboard.ordersdelivered')}
                        </Link>
                    </Col>
                </Row>
                </>
            :
                <h3 className='text-center'>
                    {t('kitchen.dashboard.adminpermiss')}
                </h3>
            }

        </Container>
    )
}